import { FloorMapSpaces } from '@api'
import { Button } from '@runeffective/evo-design-system'
import { Flex } from '@ui'
import { IDonutData } from '@ui/charts/Donut'
import { ROLES, capitalizeStr } from '@utils'
import ChartSection from 'components/ChartSection'
import { getColor } from 'components/Reports/config'
import { keys } from 'lodash'
import React, { useState } from 'react'

import typescriptNaturalSort from 'typescript-natural-sort'
import RolePopup from './rolePopup'

const formatData = (spaces: any, selectedItems: string[]) => {
  const { byId } = spaces
  const items = selectedItems.reduce(
    (result: any, id: string) => (byId[id] ? [...result, byId[id]] : result),
    []
  )

  const grouped = items.reduce((result: any, item: any) => {
    const {
      spaceAssignment: { employee, sharedEmployees },
    } = item

    if (employee) {
      return result[employee.role]
        ? {
            ...result,
            [employee.role]: [...result[employee.role], employee],
          }
        : {
            ...result,
            [employee.role]: [employee],
          }
    }

    if (sharedEmployees?.length) {
      return sharedEmployees.reduce((res: any, emp: any) => {
        if (res && emp.role in res) {
          return {
            ...res,
            [emp.role]: [...res[emp.role], emp],
          }
        } else {
          return {
            ...res,
            [emp.role]: [emp],
          }
        }
      }, result)
    }

    return result
  }, {})

  return keys(grouped)
    .sort((k1, k2) => typescriptNaturalSort(k1, k2))
    .reduce((result: IDonutData[], key, i) => {
      if (key === 'Unoccupied') {
        return result
      }
      const roleKey = key.toUpperCase()
      const role = ROLES[roleKey as keyof typeof ROLES]
      return [
        ...result,
        {
          key,
          label: role,
          color: `#${getColor(i)}`,
          value: grouped[key].length,
          percent: Math.round((grouped[key].length / items.length) * 100),
        },
      ]
    }, [])
}

const RoleSection = ({
  spaces,
  selectedItems,
  allEmployeesList,
}: {
  spaces: FloorMapSpaces
  selectedItems: string[]
  allEmployeesList: string[]
}) => {
  const chartData = formatData(spaces, selectedItems)
  const [rolePopupOpen, setRolePopupOpen] = useState(false)

  return (
    <div style={{ margin: '10px' }}>
      <ChartSection chartType="donut" colName="" description="" data={chartData} />
      <Flex style={{ width: '100%', margin: '5px' }} direction="row" justify="space-between">
        {/* <Button layout="secondary" onClick={() => {setRolePopupOpen(true)}} size="small">
          Update roles
        </Button> */}
      </Flex>
      <RolePopup
        setRolePopupOpen={setRolePopupOpen}
        rolePopupOpen={rolePopupOpen}
        selectedSpaces={selectedItems}
        allEmployeesList={allEmployeesList}
      />
    </div>
  )
}

export default RoleSection
